﻿export const TemplateSubCategories = {
    WALKAROUNDCHECK: "WalkaroundCheck",
    ASSETGENERIC: "AssetGeneric",
};